import { Select } from 'antd'
import SelectArrowIcon from 'components/icons/SelectArrowIcon'
import React from 'react'
import styled from 'styled-components'
const StyledSelectComponent = styled(Select)(({ width }) => {
  return {
    '.ant-select-selector': {
      width: `${width} !important`,
      borderRadius: '10px !important',
    },
    '.ant-select-selection-item': {
      fontWeight: 600,
      fontSize: 15,
    },
    '.ant-select-selection-placeholder': {
      fontSize: '14px',
      fontWeight: 500,
      // line-height: 24px;
    },
  }
})
export default function SelectComponent({
  options,
  value,
  placeholder,
  width,
  onChange,
  showSearch,
  allowClear,
  searchBy = 'label',
  size = 'large',
  listHeight = 250,
  listItemHeight = 10,
}) {
  return (
    <StyledSelectComponent
      options={options}
      value={value}
      suffixIcon={<SelectArrowIcon />}
      placeholder={placeholder}
      listItemHeight={listItemHeight}
      listHeight={listHeight}
      size={size}
      width={width}
      allowClear={allowClear}
      onChange={onChange}
      showSearch={showSearch}
      filterOption={(inputValue, option) =>
        option[searchBy]
          ?.toString()
          ?.toLowerCase()
          .indexOf(inputValue?.toString().toLowerCase()) !== -1
      }
    />
  )
}
